import { AdminPayrollTypePackageError } from '@/views/admin-payroll-type-package/admin-payroll-type-package.error';

export default AdminPayrollTypePackageError;
